/**
 * Common field translations (fields that appear across multiple DocTypes).
 * Key: `common:${fieldname}`
 * Value: { en: string, th: string }
 */
export const commonTranslations: Record<string, { en: string; th: string }> = {
  "common:name": { en: "ID", th: "รหัส" },
  "common:creation": { en: "Created On", th: "สร้างเมื่อ" },
  "common:modified": { en: "Last Modified", th: "แก้ไขล่าสุด" },
  "common:owner": { en: "Owner", th: "เจ้าของ" },
  "common:modified_by": { en: "Modified By", th: "แก้ไขโดย" },
  // Batch and sample fields (common across doctypes)
  "common:max_sample_quantity": { en: "Max Sample Quantity", th: "จำนวนตัวอย่างสูงสุด" },
  "common:max_sample_qty": { en: "Max Sample Quantity", th: "จำนวนตัวอย่างสูงสุด" },
  "common:max_sample": { en: "Max Sample Quantity", th: "จำนวนตัวอย่างสูงสุด" },
  "common:retain_sample": { en: "Retain Sample", th: "เก็บตัวอย่าง" },
  "common:create_new_batch": { en: "Automatically Create New Batch", th: "สร้างล็อตใหม่อัตโนมัติ" },
  "common:batch_number_series": { en: "Batch Number Series", th: "ชุดหมายเลขล็อต" },
  "common:has_expiry_date": { en: "Has Expiry Date", th: "มีวันหมดอายุ" },
  // Sales fields (common)
  "common:sales_uom": { en: "Sales UOM", th: "หน่วยขาย" },
  "common:sales_price_list": { en: "Sales Price List", th: "รายการราคาขาย" },
  "common:customer": { en: "Customer", th: "ลูกค้า" },
  "common:customer_name": { en: "Customer Name", th: "ชื่อลูกค้า" },
  "common:customer_group": { en: "Customer Group", th: "กลุ่มลูกค้า" },
  "common:customer_items": { en: "Customer Items", th: "สินค้าลูกค้า" },
  "common:ref_code": { en: "Ref Code", th: "รหัสอ้างอิง" },
  "common:grant_commission": { en: "Grant Commission", th: "ให้ค่าคอมมิชชั่น" },
  "common:max_discount": { en: "Max Discount (%)", th: "ส่วนลดสูงสุด (%)" },
  "common:selling_cost_center": { en: "Selling Cost Center", th: "ศูนย์ต้นทุนขาย" },
  // Tax fields (common)
  "common:tax_category": { en: "Tax Category", th: "หมวดภาษี" },
  "common:gst_hsn_code": { en: "GST HSN Code", th: "รหัส HSN สำหรับ GST" },
  "common:hsn_code": { en: "HSN Code", th: "รหัส HSN" },
  "common:tax_code": { en: "Tax Code", th: "รหัสภาษี" },
  "common:item_tax_template": { en: "Item Tax Template", th: "เทมเพลตภาษีสินค้า" },
  "common:valid_from": { en: "Valid From", th: "ใช้ได้ตั้งแต่" },
  "common:minimum_net_rate": { en: "Minimum Net Rate", th: "อัตราสุทธิขั้นต่ำ" },
  "common:maximum_net_rate": { en: "Maximum Net Rate", th: "อัตราสุทธิสูงสุด" },
  // Manufacturing fields (common)
  "common:default_bom": { en: "Default BOM", th: "BOM เริ่มต้น" },
  "common:default_item_manufacturer": { en: "Default Item Manufacturer", th: "ผู้ผลิตสินค้าเริ่มต้น" },
  "common:default_manufacturer_part_no": { en: "Default Manufacturer Part No", th: "หมายเลขชิ้นส่วนผู้ผลิตเริ่มต้น" },
  // Quality fields (common)
  "common:inspection_required_before_purchase": { en: "Inspection Required before Purchase", th: "ต้องตรวจสอบก่อนซื้อ" },
  "common:inspection_required_before_delivery": { en: "Inspection Required before Delivery", th: "ต้องตรวจสอบก่อนส่งมอบ" },
  // UI labels for items table
  "common:ui_total_items": { en: "Total Items", th: "รายการทั้งหมด" },
  "common:ui_item": { en: "item", th: "รายการ" },
  "common:ui_items": { en: "items", th: "รายการ" },
  "common:ui_no_items": { en: "No items", th: "ไม่มีรายการ" },
  "common:ui_unit": { en: "unit", th: "หน่วย" },
  "common:ui_units": { en: "units", th: "หน่วย" },
  "common:ui_total": { en: "total", th: "รวม" },
  "common:ui_subtotal": { en: "Subtotal", th: "ยอดรวมย่อย" },
  "common:ui_items_subtotal": { en: "Items Subtotal", th: "ยอดรวมรายการ" },
  "common:ui_items_total": { en: "Items Total", th: "ยอดรวมรายการทั้งหมด" },
  "common:ui_average_price": { en: "Average Price", th: "ราคาเฉลี่ย" },
  "common:ui_per_item": { en: "per item", th: "ต่อรายการ" },
  "common:ui_before_discounts": { en: "Before discounts", th: "ก่อนส่วนลด" },
  "common:ui_applied_to_items": { en: "Applied to items", th: "ใช้กับรายการ" },
  "common:ui_after_discount": { en: "after discount", th: "หลังส่วนลด" },
  // Status Summary UI labels
  "common:ui_order_status": { en: "Order Status", th: "สถานะคำสั่งซื้อ" },
  "common:ui_overall_progress": { en: "Overall Progress", th: "ความคืบหน้าทั้งหมด" },
  "common:ui_average_completion": { en: "Average completion", th: "ความคืบหน้าเฉลี่ย" },
  "common:ui_delivered": { en: "Delivered", th: "จัดส่งแล้ว" },
  "common:ui_amount_billed": { en: "Amount Billed", th: "จำนวนที่เรียกเก็บ" },
  "common:ui_picked": { en: "Picked", th: "เตรียมแล้ว" },
  "common:ui_not_started": { en: "Not Started", th: "ยังไม่เริ่ม" },
  "common:ui_fully_billed": { en: "Fully Billed", th: "เรียกเก็บครบแล้ว" },
  "common:ui_not_billed": { en: "Not Billed", th: "ยังไม่เรียกเก็บ" },
  "common:ui_fully_picked": { en: "Fully Picked", th: "เตรียมครบแล้ว" },
  "common:ui_not_picked": { en: "Not Picked", th: "ยังไม่เตรียม" },
  "common:ui_partial": { en: "Partial", th: "บางส่วน" },
  "common:ui_no_items_delivered_yet": { en: "No items delivered yet", th: "ยังไม่มีรายการจัดส่ง" },
  "common:ui_all_items_delivered": { en: "All items delivered", th: "รายการทั้งหมดจัดส่งแล้ว" },
  "common:ui_percent_of_items_delivered": { en: "{percentage}% of items delivered", th: "{percentage}% ของรายการจัดส่งแล้ว" },
  "common:ui_no_items_billed_yet": { en: "No items billed yet", th: "ยังไม่มีรายการเรียกเก็บ" },
  "common:ui_all_items_billed": { en: "All items billed", th: "รายการทั้งหมดเรียกเก็บแล้ว" },
  "common:ui_percent_of_items_billed": { en: "{percentage}% of items billed", th: "{percentage}% ของรายการเรียกเก็บแล้ว" },
  "common:ui_no_items_picked_yet": { en: "No items picked yet", th: "ยังไม่มีรายการเตรียม" },
  "common:ui_all_items_picked": { en: "All items picked", th: "รายการทั้งหมดเตรียมแล้ว" },
  "common:ui_percent_of_items_picked": { en: "{percentage}% of items picked", th: "{percentage}% ของรายการเตรียมแล้ว" },
  "common:ui_not_delivered": { en: "Not Delivered", th: "ยังไม่จัดส่ง" },
  "common:ui_to_deliver": { en: "To Deliver", th: "รอจัดส่ง" },
  // Status value translations (dynamic data)
  "common:status_draft": { en: "Draft", th: "ร่าง" },
  "common:status_submitted": { en: "Submitted", th: "ส่งแล้ว" },
  "common:status_to_deliver": { en: "To Deliver", th: "รอจัดส่ง" },
  "common:status_not_delivered": { en: "Not Delivered", th: "ยังไม่จัดส่ง" },
  "common:status_delivered": { en: "Delivered", th: "จัดส่งแล้ว" },
  "common:status_completed": { en: "Completed", th: "เสร็จสมบูรณ์" },
  "common:status_cancelled": { en: "Cancelled", th: "ยกเลิก" },
  "common:status_to_bill": { en: "To Bill", th: "รอเรียกเก็บ" },
  "common:status_billed": { en: "Billed", th: "เรียกเก็บแล้ว" },
  "common:status_not_billed": { en: "Not Billed", th: "ยังไม่เรียกเก็บ" },
  "common:status_to_pick": { en: "To Pick", th: "รอเตรียม" },
  "common:status_picked": { en: "Picked", th: "เตรียมแล้ว" },
  "common:status_not_picked": { en: "Not Picked", th: "ยังไม่เตรียม" },
  "common:status_partial": { en: "Partial", th: "บางส่วน" },
  "common:status_not_started": { en: "Not Started", th: "ยังไม่เริ่ม" },
  // Order Header UI labels
  "common:ui_order_date": { en: "Order Date", th: "วันที่สั่งซื้อ" },
  "common:ui_delivery_date": { en: "Delivery Date", th: "วันที่จัดส่ง" },
  "common:ui_status": { en: "Status", th: "สถานะ" },
  "common:ui_day": { en: "day", th: "วัน" },
  "common:ui_days": { en: "days", th: "วัน" },
  "common:ui_left": { en: "left", th: "เหลือ" },
  "common:ui_due_today": { en: "Due today", th: "ครบกำหนดวันนี้" },
  "common:ui_overdue": { en: "overdue", th: "เลยกำหนด" },
  "common:ui_total_amount": { en: "Total Amount", th: "ยอดรวมทั้งหมด" },
  "common:ui_price_list": { en: "Price List", th: "รายการราคา" },
  "common:ui_rate": { en: "Rate", th: "อัตรา" },
  "common:ui_valid_from": { en: "Valid From", th: "ใช้ได้ตั้งแต่" },
  "common:ui_valid_to": { en: "Valid To", th: "ใช้ได้จนถึง" },
  "common:ui_packing_unit": { en: "Packing Unit", th: "หน่วยบรรจุ" },
  "common:ui_save": { en: "Save", th: "บันทึก" },
  "common:ui_customer": { en: "Customer", th: "ลูกค้า" },
  "common:ui_company": { en: "Company", th: "บริษัท" },
  "common:ui_yes": { en: "Yes", th: "ใช่" },
  "common:ui_no": { en: "No", th: "ไม่" },
  // Empty state UI labels
  "common:ui_no_data": { en: "No data", th: "ไม่มีข้อมูล" },
  "common:ui_click_to_add": { en: "Click to add", th: "คลิกเพื่อเพิ่ม" },
  // Section title translations — Item Customization Template
  "common:section_template_info": { en: "Template Info", th: "ข้อมูลแม่แบบ" },
  "common:section_fields": { en: "Fields", th: "ฟิลด์" },
  "common:section_rules": { en: "Rules", th: "กฎเงื่อนไข" },
  "common:section_linked_products": { en: "Linked Products", th: "สินค้าที่เชื่อมโยง" },
  // Section title translations
  "common:section_status_summary": { en: "Status Summary", th: "สรุปสถานะ" },
  "common:section_items": { en: "Items", th: "รายการสินค้า" },
  "common:section_additional_discount_and_payment": { en: "Additional Discount and Payment", th: "ส่วนลดเพิ่มเติมและการชำระเงิน" },
  "common:section_additional_discounts": { en: "Additional Discounts", th: "ส่วนลดเพิ่มเติม" },
  "common:section_additional_discount": { en: "Additional Discount", th: "ส่วนลดเพิ่มเติม" },
  "common:section_payment": { en: "Payment", th: "การชำระเงิน" },
  "common:section_payment_and_totals": { en: "Payment & Totals", th: "การชำระเงินและยอดรวม" },
  "common:section_totals": { en: "Totals", th: "ยอดรวม" },
  "common:section_total": { en: "Total", th: "รวม" },
  "common:section_currency_and_price_list": { en: "Currency & Price List", th: "สกุลเงินและรายการราคา" },
  "common:section_currency_and_price_list_alt": { en: "Currency and Price List", th: "สกุลเงินและรายการราคา" },
  "common:section_currency": { en: "Currency", th: "สกุลเงิน" },
  "common:section_price_list": { en: "Price List", th: "รายการราคา" },
  "common:section_customer": { en: "Customer", th: "ลูกค้า" },
  "common:section_address": { en: "Address", th: "ที่อยู่" },
  "common:section_address_and_contact": { en: "Address & Contact", th: "ที่อยู่และการติดต่อ" },
  "common:section_billing_address": { en: "Billing Address", th: "ที่อยู่เรียกเก็บเงิน" },
  "common:section_shipping_address": { en: "Shipping Address", th: "ที่อยู่จัดส่ง" },
  "common:section_contact": { en: "Contact", th: "ติดต่อ" },
  "common:section_shipping": { en: "Shipping", th: "การจัดส่ง" },
  "common:section_terms": { en: "Terms", th: "เงื่อนไข" },
  "common:section_more_info": { en: "More Info", th: "ข้อมูลเพิ่มเติม" },
  "common:section_sales_team": { en: "Sales Team", th: "ทีมขาย" },
  "common:section_commission": { en: "Commission", th: "ค่าคอมมิชชั่น" },
  "common:section_reorder_level_based_on_warehouse": { en: "Reorder level based on Warehouse", th: "ระดับการสั่งซื้อใหม่ตามคลังสินค้า" },
  "common:section_reorder_levels": { en: "Reorder Levels", th: "ระดับการสั่งซื้อใหม่" },
  "common:section_deferred_accounting": { en: "Deferred Accounting", th: "บัญชีรอตัดบัญชี" },
  "common:section_accounting": { en: "Accounting", th: "บัญชี" },
  "common:section_sales": { en: "Sales", th: "ขาย" },
  "common:section_tax": { en: "Tax", th: "ภาษี" },
  "common:section_taxes": { en: "Taxes", th: "ภาษี" },
  "common:section_quality": { en: "Quality", th: "คุณภาพ" },
  "common:section_purchase": { en: "Purchase", th: "ซื้อ" },
  "common:section_customer_details": { en: "Customer Details", th: "รายละเอียดลูกค้า" },
  "common:section_customer_items": { en: "Customer Items", th: "สินค้าลูกค้า" },
  // Tab label translations
  "common:tab_details": { en: "Details", th: "รายละเอียด" },
  "common:tab_detail": { en: "Detail", th: "รายละเอียด" },
  "common:tab_address_and_contact": { en: "Address & Contact", th: "ที่อยู่และการติดต่อ" },
  "common:tab_address_and_contact_alt": { en: "Address and Contact", th: "ที่อยู่และการติดต่อ" },
  "common:tab_terms": { en: "Terms", th: "เงื่อนไข" },
  "common:tab_more_info": { en: "More Info", th: "ข้อมูลเพิ่มเติม" },
  "common:tab_more_information": { en: "More Information", th: "ข้อมูลเพิ่มเติม" },
  "common:tab_additional_info": { en: "Additional Info", th: "ข้อมูลเพิ่มเติม" },
  "common:tab_connection": { en: "Connection", th: "การเชื่อมต่อ" },
  "common:tab_connections": { en: "System Connections", th: "การเชื่อมต่อระบบ" },
  "common:tab_links": { en: "Links", th: "ลิงก์" },
  "common:tab_dashboard": { en: "Dashboard", th: "แดชบอร์ด" },
  "common:tab_item_price": { en: "Item Price", th: "ราคาสินค้า" },
  "common:tab_inventory": { en: "Inventory", th: "สินค้าคงคลัง" },
  "common:tab_accounting": { en: "Accounting", th: "บัญชี" },
  "common:tab_sales": { en: "Sales", th: "ขาย" },
  "common:tab_tax": { en: "Tax", th: "ภาษี" },
  "common:tab_quality": { en: "Quality", th: "คุณภาพ" },
  "common:tab_purchase": { en: "Purchase", th: "ซื้อ" },
  
  // Connection group labels
  "common:connection_group_pricing": { en: "Pricing", th: "ราคา" },
  "common:connection_group_sales": { en: "Sales", th: "ขาย" },
  "common:connection_group_purchase": { en: "Purchase", th: "ซื้อ" },
  "common:connection_group_stock": { en: "Stock", th: "สต็อก" },
  "common:connection_group_manufacturing": { en: "Manufacturing", th: "การผลิต" },
  "common:connection_group_other": { en: "Other", th: "อื่นๆ" },
  "common:connection_group_connections": { en: "Connections", th: "การเชื่อมต่อ" },
  
  // DocType name translations (for connection cards)
  "common:doctype_bom": { en: "BOM", th: "สูตรการผลิต (BOM)" },
  "common:doctype_product_bundle": { en: "Product Bundle", th: "ชุดสินค้าหลายรายการขายรวมกัน" },
  "common:doctype_item_alternative": { en: "Item Alternative", th: "สินค้าทดแทน" },
  "common:doctype_work_order": { en: "Work Order", th: "คำสั่งผลิต" },
  "common:doctype_serial_no": { en: "Serial No", th: "หมายเลขซีเรียล" },
  "common:doctype_batch": { en: "Batch", th: "ล็อต" },
  "common:doctype_stock_ledger_entry": { en: "Stock Ledger Entry", th: "รายการบัญชีสต็อก" },
  "common:doctype_sales_order": { en: "Sales Order", th: "คำสั่งขาย" },
  "common:doctype_purchase_order": { en: "Purchase Order", th: "ใบสั่งซื้อ" },
  "common:doctype_sales_invoice": { en: "Sales Invoice", th: "ใบแจ้งหนี้ขาย" },
  "common:doctype_purchase_invoice": { en: "Purchase Invoice", th: "ใบแจ้งหนี้ซื้อ" },
  "common:doctype_delivery_note": { en: "Delivery Note", th: "ใบส่งของ" },
  "common:doctype_purchase_receipt": { en: "Purchase Receipt", th: "ใบรับสินค้า" },
  "common:doctype_stock_entry": { en: "Stock Entry", th: "รายการสต็อก" },
  "common:doctype_stock_reconciliation": { en: "Stock Reconciliation", th: "กระทบยอดสต็อก" },
  "common:doctype_material_request": { en: "Material Request", th: "คำขอวัสดุ" },
  "common:doctype_quotation": { en: "Quotation", th: "ใบเสนอราคา" },
  "common:doctype_supplier_quotation": { en: "Supplier Quotation", th: "ใบเสนอราคาจากผู้ขาย" },
  "common:doctype_item_price": { en: "Item Price", th: "ราคาสินค้า" },
  "common:doctype_pricing_rule": { en: "Pricing Rule", th: "กฎราคา" },
  "common:doctype_payment_entry": { en: "Payment Entry", th: "รายการชำระเงิน" },
  // Sales Team UI labels
  "common:ui_sales_team_field_missing": { en: "Sales Team field missing", th: "ไม่พบฟิลด์ทีมขาย" },
  "common:ui_no_sales_team_entries": { en: "No sales team entries", th: "ไม่มีรายการทีมขาย" },
  "common:ui_order_total": { en: "Order Total", th: "ยอดรวมคำสั่งซื้อ" },
  "common:ui_commission_pool": { en: "Commission Pool", th: "ค่าคอมมิชชั่นรวม" },
  "common:ui_of_order": { en: "of order", th: "ของคำสั่งซื้อ" },
  "common:ui_team_members": { en: "Team Members", th: "สมาชิกทีม" },
  "common:ui_person": { en: "person", th: "คน" },
  "common:ui_people": { en: "people", th: "คน" },
  "common:ui_avg": { en: "avg", th: "เฉลี่ย" },
  "common:ui_each": { en: "each", th: "ต่อคน" },
  "common:ui_top_earner": { en: "Top Earner", th: "ผู้ได้รับสูงสุด" },
  "common:ui_commission_earned": { en: "Commission Earned", th: "ค่าคอมมิชชั่นที่ได้รับ" },
  "common:ui_handles_percent_of_order": { en: "Handles {percentage}% of this order", th: "รับผิดชอบ {percentage}% ของคำสั่งซื้อนี้" },
  "common:ui_sales_share": { en: "Sales Share", th: "ส่วนแบ่งการขาย" },
  "common:ui_of": { en: "of", th: "ของ" },
  "common:ui_commission_rate": { en: "Commission Rate", th: "อัตราค่าคอมมิชชั่น" },
  "common:ui_base_rate": { en: "base rate", th: "อัตราพื้นฐาน" },
  "common:ui_effective_rate": { en: "Effective Rate", th: "อัตราที่แท้จริง" },
  "common:ui_actual_rate": { en: "actual rate", th: "อัตราจริง" },
  "common:ui_total_share": { en: "Total Share", th: "ส่วนแบ่งรวม" },
  "common:ui_total_sales_amount": { en: "Total Sales Amount", th: "ยอดขายรวม" },
  "common:ui_total_commission_earned": { en: "Total Commission Earned", th: "ค่าคอมมิชชั่นรวมที่ได้รับ" },
  
  // Child table UI labels
  "common:ui_actions": { en: "Actions", th: "การดำเนินการ" },
  "common:ui_add_row": { en: "Add row", th: "เพิ่มแถว" },
  "common:ui_add_row_button": { en: "Add Row", th: "เพิ่มแถว" },
  "common:ui_no_rows": { en: "No rows. Click \"Add Row\" to create one", th: "ไม่มีแถว คลิก \"เพิ่มแถว\" เพื่อสร้าง" },
  "common:ui_no_rows_click_add": { en: "No rows. Click \"Add Row\" to create one", th: "ไม่มีแถว คลิก \"เพิ่มแถว\" เพื่อสร้าง" },
  
  // Search placeholders
  "common:ui_search_default_bom": { en: "Search Default BOM...", th: "ค้นหา BOM เริ่มต้น..." },
  "common:ui_search_default_item_manufacturer": { en: "Search Default Item Manufacturer...", th: "ค้นหาผู้ผลิตสินค้าเริ่มต้น..." },
  
  // Connection tab UI labels
  "common:ui_connections_load_failed": { en: "Failed to load connections. Please try again.", th: "โหลดการเชื่อมต่อไม่สำเร็จ โปรดลองอีกครั้ง" },
  "common:ui_no_connections_available": { en: "No connections available", th: "ไม่มีการเชื่อมต่อ" },
  "common:ui_create_new_doctype": { en: "Create new {doctype}", th: "สร้าง {doctype} ใหม่" },
  "common:ui_related_doctype_records": { en: "Related {doctype} records", th: "บันทึก {doctype} ที่เกี่ยวข้อง" },
  
  // =========================
  // Detail page modals (generic)
  // =========================
  "common:ui_general": { en: "General", th: "ทั่วไป" },
  "common:ui_modal_edit_fields": { en: "Edit Fields", th: "แก้ไขข้อมูล" },
  "common:ui_modal_update_information_below": { en: "Update the information below", th: "อัปเดตข้อมูลด้านล่าง" },
  "common:ui_modal_save": { en: "Save", th: "บันทึก" },
  "common:ui_modal_saving": { en: "Saving...", th: "กำลังบันทึก..." },
  "common:ui_modal_save_changes": { en: "Save changes", th: "บันทึกการเปลี่ยนแปลง" },
  "common:ui_modal_save_create_first_short": { en: "Please save/create this document first", th: "โปรดบันทึก/สร้างเอกสารนี้ก่อน" },
  "common:ui_modal_save_create_first_long": { en: "Please save/create this document first before editing in modal.", th: "โปรดบันทึก/สร้างเอกสารนี้ก่อน จึงจะสามารถแก้ไขผ่านหน้าต่างแก้ไขได้" },
  "common:ui_modal_save_failed_no_handler": { en: "Save failed: No save handler available. Please report this error.", th: "บันทึกล้มเหลว: ไม่พบตัวจัดการการบันทึก โปรดแจ้งทีมงาน" },

  // =========================
  // Gallery actions modal (Item detail)
  // =========================
  "common:ui_gallery_actions_title": { en: "Gallery Actions", th: "จัดการแกลเลอรี" },
  "common:ui_gallery_actions_description": { en: "Manage your product images gallery", th: "จัดการรูปภาพและวิดีโอของสินค้า" },
  "common:ui_gallery_add_images": { en: "Add Images", th: "เพิ่มรูปภาพ" },
  "common:ui_gallery_add_images_description": { en: "Upload new images to the gallery", th: "อัปโหลดรูปภาพใหม่เข้าแกลเลอรี" },
  "common:ui_gallery_choose_primary_image": { en: "Choose primary image", th: "เลือกรูปหลัก" },
  "common:ui_gallery_done_choosing_primary": { en: "Done choosing primary", th: "เสร็จสิ้นการเลือกรูปหลัก" },
  "common:ui_gallery_choose_primary_image_description": { en: "Select which image is the main product image", th: "เลือกรูปที่จะใช้เป็นรูปหลักของสินค้า" },
  "common:ui_gallery_exit_primary_selection_description": { en: "Exit primary selection mode", th: "ออกจากโหมดเลือกรูปหลัก" },
  "common:ui_gallery_rearrange_images": { en: "Rearrange Images", th: "จัดเรียงรูปภาพ" },
  "common:ui_gallery_done_rearranging": { en: "Done rearranging", th: "เสร็จสิ้นการจัดเรียง" },
  "common:ui_gallery_rearrange_images_description": { en: "Drag images to reorder them", th: "ลากรูปภาพเพื่อเปลี่ยนลำดับ" },
  "common:ui_gallery_exit_rearrange_mode_description": { en: "Exit rearrange mode", th: "ออกจากโหมดจัดเรียง" },
  "common:ui_gallery_add_videos": { en: "Add Videos", th: "เพิ่มวิดีโอ" },
  "common:ui_gallery_max_videos_allowed": { en: "Maximum 3 videos allowed", th: "อนุญาตสูงสุด 3 วิดีโอ" },
  "common:ui_gallery_upload_videos_to_gallery": { en: "Upload videos to the gallery", th: "อัปโหลดวิดีโอเข้าแกลเลอรี" },
  "common:ui_gallery_choose_primary_video": { en: "Choose primary video", th: "เลือกวิดีโอหลัก" },
  "common:ui_gallery_done_choosing_primary_video": { en: "Done choosing primary video", th: "เสร็จสิ้นการเลือกวิดีโอหลัก" },
  "common:ui_gallery_choose_primary_video_description": { en: "Select which video is the main product video", th: "เลือกวิดีโอที่จะใช้เป็นวิดีโอหลักของสินค้า" },
  "common:ui_gallery_exit_primary_video_selection_description": { en: "Exit primary video selection mode", th: "ออกจากโหมดเลือกวิดีโอหลัก" },
  "common:ui_gallery_remove_media": { en: "Remove Media", th: "ลบสื่อ" },
  "common:ui_gallery_cannot_remove_only_media": { en: "Cannot remove the only media item", th: "ไม่สามารถลบสื่อชิ้นสุดท้ายได้" },
  "common:ui_gallery_select_media_to_remove": { en: "Select images or videos to remove from the gallery", th: "เลือกรูปภาพหรือวิดีโอที่ต้องการลบออกจากแกลเลอรี" },
  "common:ui_gallery_no_product_images_title": { en: "No product images", th: "ไม่มีรูปภาพสินค้า" },
  "common:ui_gallery_no_product_images_subtitle": { en: "Add images to showcase your product from multiple angles", th: "เพิ่มรูปภาพเพื่อแสดงสินค้าในหลายมุมมอง" },
  "common:ui_gallery_adding": { en: "Adding...", th: "กำลังเพิ่ม..." },

  // Gallery floating action banners
  "common:ui_done": { en: "Done", th: "เสร็จสิ้น" },
  "common:ui_gallery_banner_choose_primary_image": { en: "Choose primary image", th: "เลือกรูปหลัก" },
  "common:ui_gallery_banner_choose_primary_image_hint": {
    en: "Tap the star icon on an image to set it as primary",
    th: "แตะไอคอนดาวบนรูปภาพเพื่อกำหนดเป็นรูปหลัก",
  },
  "common:ui_gallery_banner_choose_primary_video": { en: "Choose primary video", th: "เลือกวิดีโอหลัก" },
  "common:ui_gallery_banner_choose_primary_video_hint": {
    en: "Tap the video icon on a video to set it as primary",
    th: "แตะไอคอนวิดีโอบนวิดีโอเพื่อกำหนดเป็นวิดีโอหลัก",
  },

  // Gallery rearrange/delete mode banners
  "common:ui_gallery_banner_rearrange_title": { en: "Drag images to reorder them", th: "ลากรูปภาพเพื่อจัดลำดับใหม่" },
  "common:ui_gallery_banner_rearrange_hint": { en: "Use the drag handle to move images", th: "ใช้ตัวจับลากเพื่อย้ายรูปภาพ" },
  "common:ui_gallery_select_images_to_remove": { en: "Select images to remove", th: "เลือกรูปภาพที่ต้องการลบ" },
  "common:ui_gallery_tap_images_to_select": { en: "Tap images to select them", th: "แตะรูปภาพเพื่อเลือก" },
  "common:ui_gallery_selected": { en: "selected", th: "ที่เลือก" },
  "common:ui_gallery_image": { en: "image", th: "รูปภาพ" },
  "common:ui_gallery_images": { en: "images", th: "รูปภาพ" },
  "common:ui_cancel": { en: "Cancel", th: "ยกเลิก" },
  "common:ui_delete": { en: "Delete", th: "ลบ" },
  "common:ui_removing": { en: "Removing...", th: "กำลังลบ..." },
  "common:ui_gallery_confirm_remove_from_gallery": {
    en: "Remove {count} {imageWord} from the gallery?",
    th: "ต้องการลบ{count} {imageWord}ออกจากแกลเลอรีหรือไม่?",
  },

  // =========================
  // Dashboard tab (generic)
  // =========================
  "common:ui_dashboard_failed_to_load": {
    en: "Failed to load dashboard data. Please try refreshing the page.",
    th: "โหลดข้อมูลแดชบอร์ดไม่สำเร็จ โปรดลองรีเฟรชหน้าอีกครั้ง",
  },
  "common:ui_dashboard_no_data_configured": {
    en: "No dashboard data configured for this document yet.",
    th: "ยังไม่มีการตั้งค่าข้อมูลแดชบอร์ดสำหรับเอกสารนี้",
  },
  "common:ui_no_data_available": { en: "No data available", th: "ไม่มีข้อมูล" },
  "common:ui_no_stock_data_available": { en: "No stock data available", th: "ไม่มีข้อมูลสต็อก" },

  // Stock labels (used in dashboard cards/charts)
  "common:ui_actual": { en: "Actual", th: "คงเหลือจริง" },
  "common:ui_reserved": { en: "Reserved", th: "จองแล้ว" },
  "common:ui_incoming": { en: "Incoming", th: "กำลังเข้า" },
  "common:ui_available": { en: "Available", th: "พร้อมใช้" },
  "common:ui_locations": { en: "Locations", th: "ตำแหน่ง" },
  "common:ui_total_stock": { en: "Total Stock", th: "สต็อกรวม" },
  "common:ui_percent_of_total": { en: "% of Total", th: "% ของทั้งหมด" },
  "common:ui_stock_balance": { en: "Stock Balance", th: "สรุปสต็อก" },
  "common:ui_total_label": { en: "Total:", th: "รวม:" },
  "common:ui_parent_label": { en: "Parent:", th: "คลังหลัก:" },
  "common:ui_healthy": { en: "Healthy", th: "ปกติ" },
  "common:ui_low": { en: "Low", th: "ต่ำ" },
  "common:ui_critical": { en: "Critical", th: "วิกฤต" },
  "common:ui_of_total": { en: "of total", th: "ของทั้งหมด" },
  "common:ui_of_actual": { en: "of actual", th: "ของคงเหลือจริง" },
  "common:ui_chart_type_not_supported": {
    en: 'Chart type "{chartType}" is not yet supported. Only "bar" and "stock_balance" charts are available.',
    th: 'ยังไม่รองรับกราฟประเภท "{chartType}" รองรับเฉพาะ "bar" และ "stock_balance" เท่านั้น',
  },
  "common:ui_warehouse_n": { en: "Warehouse {n}", th: "คลังสินค้า {n}" },

  // Stock actions modal (dashboard -> stock summary/cards)
  "common:ui_stock_actions": { en: "Stock Actions", th: "การดำเนินการสต็อก" },
  "common:ui_manage_stock_for": { en: "Manage stock for {warehouse}", th: "จัดการสต็อกสำหรับ {warehouse}" },
  "common:ui_manage_stock_actions": { en: "Manage stock actions", th: "จัดการการดำเนินการสต็อก" },
  "common:ui_create_stock_entry": { en: "Create Stock Entry", th: "สร้างรายการสต็อก" },
  "common:ui_opening_stock": { en: "Opening Stock", th: "สต็อกตั้งต้น" },
  "common:ui_stock_reconciliation": { en: "Stock Reconciliation", th: "กระทบยอดสต็อก" },

  // Stock action registry labels/descriptions
  "common:ui_stock_action_material_receipt": { en: "Material Receipt", th: "รับเข้าสต็อก" },
  "common:ui_stock_action_material_receipt_desc": {
    en: "Increase stock quantity (purchase, production, etc.)",
    th: "เพิ่มจำนวนสต็อก (ซื้อ, ผลิต ฯลฯ)",
  },
  "common:ui_stock_action_material_issue": { en: "Material Issue", th: "เบิกออกจากสต็อก" },
  "common:ui_stock_action_material_issue_desc": {
    en: "Decrease stock quantity (consumption, waste, etc.)",
    th: "ลดจำนวนสต็อก (ใช้งาน, ของเสีย ฯลฯ)",
  },
  "common:ui_stock_action_material_transfer": { en: "Material Transfer", th: "โอนย้ายสต็อก" },
  "common:ui_stock_action_material_transfer_desc": { en: "Transfer stock between warehouses", th: "โอนสต็อกระหว่างคลังสินค้า" },
  "common:ui_stock_action_manufacturing_entry": { en: "Manufacturing Entry", th: "บันทึกการผลิต" },
  "common:ui_stock_action_manufacturing_entry_desc": { en: "Record finished goods from production", th: "บันทึกสินค้าสำเร็จรูปจากการผลิต" },
  "common:ui_stock_action_repack_entry": { en: "Repack Entry", th: "บันทึกการแพ็คใหม่" },
  "common:ui_stock_action_repack_entry_desc": {
    en: "Repackage items (e.g., bulk to retail units)",
    th: "แพ็ค/แยกบรรจุภัณฑ์ (เช่น แพ็คใหญ่เป็นแพ็คย่อย)",
  },
  "common:ui_stock_action_opening_stock": { en: "Opening Stock", th: "สต็อกตั้งต้น" },
  "common:ui_stock_action_opening_stock_desc": {
    en: "Set initial stock quantity for a warehouse",
    th: "กำหนดจำนวนสต็อกเริ่มต้นสำหรับคลังสินค้า",
  },
  "common:ui_stock_action_stock_reconciliation": { en: "Stock Reconciliation", th: "กระทบยอดสต็อก" },
  "common:ui_stock_action_stock_reconciliation_desc": {
    en: "Reconcile physical stock with system records",
    th: "ปรับสต็อกตามจำนวนจริงเทียบกับระบบ",
  },

  // Quick action helpers
  "common:ui_incoming_value": { en: "Incoming Value", th: "มูลค่าขาเข้า" },
  "common:ui_outgoing_value": { en: "Outgoing Value", th: "มูลค่าขาออก" },
  "common:ui_transfer_value": { en: "Transfer Value", th: "มูลค่าการโอนย้าย" },
  "common:ui_locked": { en: "(Locked)", th: "(ล็อก)" },
  "common:ui_select_location": { en: "Select location", th: "เลือกตำแหน่ง" },
  "common:ui_select_locations": { en: "Select locations", th: "เลือกตำแหน่ง" },
  "common:ui_selected_location": { en: "Selected location", th: "เลือกตำแหน่งแล้ว" },
  "common:ui_selected_locations": { en: "Selected locations", th: "เลือกตำแหน่งแล้ว" },
  "common:ui_select_location_ellipsis": { en: "Select location...", th: "เลือกตำแหน่ง..." },
  "common:ui_select_destination_ellipsis": { en: "Select destination...", th: "เลือกปลายทาง..." },
  "common:ui_select_source_ellipsis": { en: "Select source...", th: "เลือกต้นทาง..." },
  "common:ui_select_warehouse_ellipsis": { en: "Select warehouse...", th: "เลือกคลังสินค้า..." },
  "common:ui_create_draft_stock_entry": { en: "Create Draft Stock Entry", th: "สร้างรายการสต็อก (ร่าง)" },
  "common:ui_create_draft_stock_reconciliation": { en: "Create Draft Stock Reconciliation", th: "สร้างรายการกระทบยอดสต็อก (ร่าง)" },

  // Quick action field/group labels
  "common:ui_default_warehouse": { en: "Default Warehouse", th: "คลังสินค้าเริ่มต้น" },
  "common:ui_select_warehouse": { en: "Select warehouse", th: "เลือกคลังสินค้า" },
  "common:ui_selected_warehouse": { en: "Selected warehouse", th: "เลือกคลังสินค้าแล้ว" },
  "common:ui_warehouse": { en: "Warehouse", th: "คลังสินค้า" },
  "common:ui_transaction_type": { en: "Transaction Type", th: "ประเภทธุรกรรม" },
  "common:ui_type": { en: "Type", th: "ประเภท" },
  "common:ui_quantity_and_price": { en: "Quantity & Price", th: "จำนวน & ราคา" },
  "common:ui_item_details": { en: "Item Details", th: "รายละเอียดสินค้า" },
  "common:ui_quantity": { en: "Quantity", th: "จำนวน" },
  "common:ui_valuation_rate": { en: "Valuation Rate", th: "อัตราตีราคา" },
  "common:ui_summary": { en: "Summary", th: "สรุป" },
  "common:ui_current_stock": { en: "Current Stock", th: "สต็อกปัจจุบัน" },
  "common:ui_value": { en: "Value", th: "มูลค่า" },

  // Stock entry quick action extra labels
  "common:ui_options": { en: "Options", th: "ตัวเลือก" },
  "common:ui_additional_options": { en: "Additional Options", th: "ตัวเลือกเพิ่มเติม" },
  "common:ui_inspection_required": { en: "Inspection Required", th: "ต้องตรวจสอบ" },
  "common:ui_require_inspection_before_receipt": {
    en: "Require inspection before receipt",
    th: "ต้องตรวจสอบก่อนรับเข้า",
  },
  "common:ui_apply_putaway_rules": { en: "Apply Putaway Rules", th: "ใช้กฎการจัดเก็บ" },
  "common:ui_apply_storage_rules_automatically": {
    en: "Apply storage rules automatically",
    th: "ใช้กฎการจัดเก็บอัตโนมัติ",
  },
  "common:ui_source": { en: "Source", th: "ต้นทาง" },
  "common:ui_destination": { en: "Destination", th: "ปลายทาง" },
  "common:ui_from_location": { en: "From Location", th: "จากตำแหน่ง" },
  "common:ui_to_location": { en: "To Location", th: "ไปยังตำแหน่ง" },
  "common:ui_select_source": { en: "Select source", th: "เลือกต้นทาง" },
  "common:ui_selected_source": { en: "Selected source", th: "เลือกต้นทางแล้ว" },
  "common:ui_select_destination": { en: "Select destination", th: "เลือกปลายทาง" },
  "common:ui_selected_destination": { en: "Selected destination", th: "เลือกปลายทางแล้ว" },
  "common:ui_select_source_location_ellipsis": { en: "Select source location...", th: "เลือกตำแหน่งต้นทาง..." },
  "common:ui_select_destination_location_ellipsis": { en: "Select destination location...", th: "เลือกตำแหน่งปลายทาง..." },
  "common:ui_unit_price": { en: "Unit Price", th: "ราคาต่อหน่วย" },
  "common:ui_basic_rate": { en: "Basic Rate", th: "อัตราพื้นฐาน" },
  "common:ui_stock_after_receipt": { en: "Stock After Receipt", th: "สต็อกหลังรับเข้า" },
  "common:ui_stock_after_issue": { en: "Stock After Issue", th: "สต็อกหลังเบิกออก" },
  "common:ui_stock_after_transfer": { en: "Stock After Transfer", th: "สต็อกหลังโอนย้าย" },
  "common:ui_stock_after_manufacture": { en: "Stock After Manufacture", th: "สต็อกหลังผลิต" },
  "common:ui_stock_after_repack": { en: "Stock After Repack", th: "สต็อกหลังแพ็คใหม่" },
  
  // Child table modal titles
  "common:ui_edit": { en: "Edit", th: "แก้ไข" },
  "common:ui_delete_row": { en: "Delete Row", th: "ลบแถว" },
  "common:ui_no_fields_available": { en: "No fields available to edit", th: "ไม่มีฟิลด์ให้แก้ไข" },
  
  // Common doctype names (for child table modals)
  
  // DocSidebar UI labels
  "common:ui_assigned_to": { en: "Assigned to", th: "มอบหมายให้" },
  "common:ui_manage_assignments": { en: "Manage Assignments", th: "จัดการการมอบหมาย" },
  "common:ui_current_assignments": { en: "Current Assignments", th: "การมอบหมายปัจจุบัน" },
  "common:ui_assign_to": { en: "Assign To", th: "มอบหมายให้" },
  "common:ui_users": { en: "Users", th: "ผู้ใช้" },
  "common:ui_search_users": { en: "Search users...", th: "ค้นหาผู้ใช้..." },
  "common:ui_user_groups": { en: "User Groups", th: "กลุ่มผู้ใช้" },
  "common:ui_search_user_groups": { en: "Search user groups...", th: "ค้นหากลุ่มผู้ใช้..." },
  "common:ui_priority": { en: "Priority", th: "ลำดับความสำคัญ" },
  "common:ui_priority_low": { en: "Low", th: "ต่ำ" },
  "common:ui_priority_medium": { en: "Medium", th: "ปานกลาง" },
  "common:ui_priority_high": { en: "High", th: "สูง" },
  "common:ui_priority_urgent": { en: "Urgent", th: "ด่วน" },
  "common:ui_comment": { en: "Comment", th: "ความคิดเห็น" },
  "common:ui_add_comment": { en: "Add a comment...", th: "เพิ่มความคิดเห็น..." },
  "common:ui_assigning": { en: "Assigning...", th: "กำลังมอบหมาย..." },
  "common:ui_assign": { en: "Assign", th: "มอบหมาย" },
  "common:ui_assign_to_me": { en: "Assign to me", th: "มอบหมายให้ฉัน" },
  "common:ui_sharing": { en: "Sharing", th: "การแชร์" },
  "common:ui_share": { en: "Share", th: "แชร์" },
  "common:ui_everyone": { en: "Everyone", th: "ทุกคน" },
  "common:ui_following": { en: "Following", th: "กำลังติดตาม" },
  "common:ui_follow": { en: "Follow", th: "ติดตาม" },
  "common:ui_unlike": { en: "Unlike", th: "ยกเลิกถูกใจ" },
  "common:ui_like": { en: "Like", th: "ถูกใจ" },
  "common:ui_add_tag": { en: "Add tag...", th: "เพิ่มแท็ก..." },
  "common:ui_attachments": { en: "Attachments", th: "ไฟล์แนบ" },
  "common:ui_history": { en: "History", th: "ประวัติ" },
  "common:ui_copy_link": { en: "Copy link", th: "คัดลอกลิงก์" },
  "common:ui_copied": { en: "Copied", th: "คัดลอกแล้ว" },
  "common:ui_anyone_with_access": { en: "Anyone with access to this workspace", th: "ทุกคนที่มีสิทธิ์เข้าถึงพื้นที่ทำงานนี้" },
  "common:ui_can_read": { en: "Can read", th: "อ่านได้" },
  "common:ui_can_write": { en: "Can write", th: "เขียนได้" },
  "common:ui_can_share": { en: "Can share", th: "แชร์ได้" },
  "common:ui_can_submit": { en: "Can submit", th: "ส่งได้" },
  "common:ui_shared_by": { en: "Shared by", th: "แชร์โดย" },
  "common:ui_existing_shares": { en: "Existing shares", th: "การแชร์ที่มีอยู่" },
  "common:ui_not_shared_yet": { en: "Not shared with anyone yet.", th: "ยังไม่ได้แชร์กับใคร" },
  "common:ui_read": { en: "Read", th: "อ่าน" },
  "common:ui_write": { en: "Write", th: "เขียน" },
  "common:ui_submit": { en: "Submit", th: "ส่ง" },
  "common:ui_add_new_user": { en: "Add new user", th: "เพิ่มผู้ใช้ใหม่" },
  "common:ui_loading_users": { en: "Loading users...", th: "กำลังโหลดผู้ใช้..." },
  "common:ui_no_matching_users": { en: "No matching users", th: "ไม่พบผู้ใช้ที่ตรงกัน" },
  "common:ui_sharing_in_progress": { en: "Sharing...", th: "กำลังแชร์..." },
  "common:ui_delete_attachment_confirm": { en: "Delete this attachment?", th: "ลบไฟล์แนบนี้หรือไม่?" },
  "common:ui_by": { en: "by", th: "โดย" },
  "common:ui_show_sidebar": { en: "Show sidebar", th: "แสดงแถบด้านข้าง" },
  "common:ui_hide_sidebar": { en: "Hide sidebar", th: "ซ่อนแถบด้านข้าง" },
  
  // Item Price Tab UI labels
  "common:ui_item_prices": { en: "Item Prices", th: "ราคาสินค้า" },
  "common:ui_price_list_entries_for_item": { en: "Price list entries for this item", th: "รายการราคาสำหรับสินค้านี้" },
  "common:ui_new_item_price": { en: "New Item Price", th: "ราคาสินค้าใหม่" },
  "common:ui_no_item_prices_found": { en: "No item prices found", th: "ไม่พบราคาสินค้า" },
  "common:ui_create_item_price": { en: "Create Item Price", th: "สร้างราคาสินค้า" },
  "common:ui_view_all_item_prices": { en: "View All Item Prices", th: "ดูราคาสินค้าทั้งหมด" },
  "common:ui_pricing_rules": { en: "Pricing Rules", th: "กฎราคา" },
  "common:ui_automatic_pricing_discount_rules": { en: "Automatic pricing and discount rules for this item", th: "กฎราคาและส่วนลดอัตโนมัติสำหรับสินค้านี้" },
  "common:ui_new_pricing_rule": { en: "New Pricing Rule", th: "กฎราคาใหม่" },
  "common:ui_no_pricing_rules_found": { en: "No pricing rules found", th: "ไม่พบกฎราคา" },
  "common:ui_create_pricing_rule": { en: "Create Pricing Rule", th: "สร้างกฎราคา" },
  "common:ui_view_all_pricing_rules": { en: "View All Pricing Rules", th: "ดูกฎราคาทั้งหมด" },
  "common:ui_buying": { en: "Buying", th: "ซื้อ" },
  "common:ui_selling": { en: "Selling", th: "ขาย" },
  "common:ui_per": { en: "per", th: "ต่อ" },
  "common:ui_min_purchase": { en: "Min. purchase", th: "ซื้อขั้นต่ำ" },
  "common:ui_batch": { en: "Batch", th: "ล็อต" },
  "common:ui_validity": { en: "Validity", th: "ความถูกต้อง" },
  "common:ui_from": { en: "From", th: "ตั้งแต่" },
  "common:ui_to": { en: "To", th: "จนถึง" },
  "common:ui_conditions": { en: "Conditions", th: "เงื่อนไข" },
  "common:ui_failed_to_load": { en: "Failed to load", th: "โหลดไม่สำเร็จ" },
  
  // Section titles for Item Price
  "common:section_basic_information": { en: "Basic Information", th: "ข้อมูลพื้นฐาน" },
  "common:section_type_and_validity": { en: "Type & Validity", th: "ประเภทและความถูกต้อง" },
  "common:section_context": { en: "Context", th: "บริบท" },
  
  // Item Price Actions Modal UI labels
  "common:ui_item_price_actions": { en: "Item Price Actions", th: "การดำเนินการราคาสินค้า" },
  "common:ui_edit_item_price": { en: "Edit Item Price", th: "แก้ไขราคาสินค้า" },
  "common:ui_manage_item_price": { en: "Manage item price", th: "จัดการราคาสินค้า" },
  "common:ui_edit_price_list_rate_dates_packing": { en: "Edit price list, rate, dates, and packing unit", th: "แก้ไขรายการราคา อัตรา วันที่ และหน่วยบรรจุ" },
  "common:ui_permanently_delete_item_price": { en: "Permanently delete this item price", th: "ลบราคาสินค้านี้อย่างถาวร" },
  "common:ui_price_details": { en: "Price Details", th: "รายละเอียดราคา" },
  "common:ui_validity_period": { en: "Validity Period", th: "ระยะเวลาที่ใช้ได้" },
  "common:ui_packing_information": { en: "Packing Information", th: "ข้อมูลการบรรจุ" },
  "common:ui_select_price_list": { en: "Select price list...", th: "เลือกรายการราคา..." },
  "common:ui_delete_confirm_item_price": { en: "Are you sure you want to delete this item price?", th: "คุณแน่ใจหรือไม่ว่าต้องการลบราคาสินค้านี้?" },
  "common:ui_saving": { en: "Saving...", th: "กำลังบันทึก..." },
  "common:ui_deleting": { en: "Deleting...", th: "กำลังลบ..." },
  "common:ui_saved": { en: "Saved", th: "บันทึกแล้ว" },
  "common:ui_deleted": { en: "Deleted", th: "ลบแล้ว" },
  "common:ui_error": { en: "Error", th: "เกิดข้อผิดพลาด" },
  
  // Section titles for Item detail page
  "common:section_product_details": { en: "Product Details", th: "รายละเอียดสินค้า" },
  "common:section_product_images_and_overview": { en: "Product Images & Overview", th: "รูปภาพและภาพรวมสินค้า" },
  "common:section_pricing": { en: "Pricing", th: "ราคา" },
  "common:section_storefront": { en: "Storefront", th: "หน้าร้าน" },
  "common:section_product_documents": { en: "Product Documents", th: "เอกสารสินค้า" },
  "common:section_personalization": { en: "Personalization", th: "การปรับแต่ง" },
  "common:section_collections": { en: "Collections", th: "คอลเลกชัน" },
  "common:section_marketplace_listings": { en: "Marketplace Listings", th: "รายการตลาดออนไลน์" },
  "common:section_inventory_settings": { en: "Inventory Settings", th: "การตั้งค่าสินค้าคงคลัง" },
  "common:section_advanced": { en: "Advanced", th: "ขั้นสูง" },
  "common:section_details": { en: "Details", th: "รายละเอียด" },
  "common:section_inventory": { en: "Inventory", th: "สินค้าคงคลัง" },
  "common:section_manufacturing": { en: "Manufacturing", th: "การผลิต" },
  "common:section_variants": { en: "Variants", th: "ตัวเลือกสินค้า" },
  "common:section_variations": { en: "Variations", th: "รูปแบบสินค้า" },

  // Section titles for Item Group detail page
  "common:section_general_settings": { en: "General Settings", th: "การตั้งค่าทั่วไป" },
  "common:section_item_group_defaults": { en: "Item Group Defaults", th: "ค่าเริ่มต้นกลุ่มสินค้า" },
  "common:section_item_tax": { en: "Item Tax", th: "ภาษีสินค้า" },

  // Tab labels (only new ones not already defined above)
  "common:tab_manufacturing": { en: "Manufacturing", th: "การผลิต" },
  "common:tab_variants": { en: "Variants", th: "ตัวเลือกสินค้า" },
  "common:tab_defaults_and_tax": { en: "Defaults & Tax", th: "ค่าเริ่มต้นและภาษี" },

  // Sidebar card UI labels
  "common:ui_payment_slips": { en: "Payment Slips", th: "สลิปชำระเงิน" },
  "common:ui_contact": { en: "Contact", th: "ผู้ติดต่อ" },
  "common:ui_mobile": { en: "Mobile", th: "มือถือ" },
  "common:ui_phone": { en: "Phone", th: "โทรศัพท์" },
  "common:ui_email": { en: "Email", th: "อีเมล" },

  // Add more common fields as needed
};

